/**
 * Initial state
 */
const initialState = {
    items: [],
    currentStationStats:null,
    statTotals:[],
    submitting:false,
    groups:[],
    groupTypes:[],
    editStationId:0
};

/**
 * Statons reducer
 */
export default function (state = initialState, action) {
    switch (action.type) {

        case "STATIONS_RESET":
            return initialState;
        case "STATIONS_CREATE_INPROGRESS":
            return {
                ...state,
                submitting:true
            };
        case "STATIONS_CREATE_SUCCESS":
            return {
                ...state,
                submitting:false
            };
        case "STATIONS_CREATE_FAILURE":
            return {
                ...state,
                submitting:false
            };

        case "STATIONS_UPDATE_INPROGRESS":
            return {
                ...state,
                submitting:true
            };
        case "STATIONS_UPDATE_SUCCESS":
            return {
                ...state,
                submitting:false
            };
        case "STATIONS_UPDATE_FAILURE":
            return {
                ...state,
                submitting:false
            };



        case "STATIONS_GET_SUCCESS":
            return {items:action.payload}

       case "STATIONS_GET_GROUPS_SUCCESS":
          return {
            ...state,
            groups: action.payload
          }


        case "STATIONS_ALL_STATS_GET_SUCCESS":
            let missingWheels = action.payload.missingWheels ? action.payload.missingWheels : 0;
            let incomingWheels = action.payload.incoming ? action.payload.incoming : 0;
            let outgoingWheels = action.payload.outgoing ? action.payload.outgoing : 0;
            //[, '', '', '', '', '', 'TIS', 'ONS']
            return {
                ...state,
                items:action.payload.stations,
                totalStats: [
                    {
                        label:'MÅN',
                        missingWheels :missingWheels,
                        incomingWheels:incomingWheels,
                        outgoingWheels:outgoingWheels,
                        total:action.payload.total
                    },
                    {
                        label:'TIS',
                        missingWheels :missingWheels,
                        incomingWheels:incomingWheels,
                        outgoingWheels:outgoingWheels,
                        total:action.payload.total
                    },
                    {
                        label:'ONS',
                        missingWheels :missingWheels,
                        incomingWheels:incomingWheels,
                        outgoingWheels:outgoingWheels,
                        total:action.payload.total
                    },
                    {
                        label:'TOR',
                        missingWheels :missingWheels,
                        incomingWheels:incomingWheels,
                        outgoingWheels:outgoingWheels,
                        total:action.payload.total
                    },
                    {
                        label:'FRE',
                        missingWheels :missingWheels,
                        incomingWheels:incomingWheels,
                        outgoingWheels:outgoingWheels,
                        total:action.payload.total
                    },
                    {
                        label:'MÅN',
                        missingWheels :missingWheels,
                        incomingWheels:incomingWheels,
                        outgoingWheels:outgoingWheels,
                        total:action.payload.total
                    },
                    {
                        label:'TIS',
                        missingWheels :missingWheels,
                        incomingWheels:incomingWheels,
                        outgoingWheels:outgoingWheels,
                        total:action.payload.total
                    },
                    {
                        label:'ONS',
                        missingWheels :missingWheels,
                        incomingWheels:incomingWheels,
                        outgoingWheels:outgoingWheels,
                        total:action.payload.total
                    },
                    {
                        label:'TOR',
                        missingWheels :missingWheels,
                        incomingWheels:incomingWheels,
                        outgoingWheels:outgoingWheels,
                        total:action.payload.total
                    },
                    {
                        label:'FRE',
                        missingWheels :missingWheels,
                        incomingWheels:incomingWheels,
                        outgoingWheels:outgoingWheels,
                        total:action.payload.total
                    }

                ]

            }
        case "STATIONS_ALL_STATS_GET_FAILURE":
            return {
                ...state
            };


        case "STATIONS_STATS_GET_SUCCESS":

            let stationStats = action.payload;
            if (!stationStats.name){
                stationStats.name="";
            }
            if (!stationStats.desiredSpikes){
                stationStats.desiredSpikes=0;
            }
            if (!stationStats.desiredFriction){
                stationStats.desiredFriction=0;
            }

            if (!stationStats.actualSpikes){
                stationStats.actualSpikes=0;
            }
            if (!stationStats.actualFriction){
                stationStats.actualFriction=0;
            }

            stationStats.desiredSpikes = parseInt(stationStats.desiredSpikes,10);
            stationStats.desiredFriction = parseInt(stationStats.desiredFriction,10);
            stationStats.actualSpikes = parseInt(stationStats.actualSpikes,10);
            stationStats.actualFriction = parseInt(stationStats.actualFriction,10);



            stationStats.numberOfWheels =  parseInt(stationStats.numberOfWheels,10);
            let total=parseInt(stationStats.actualSpikes,10)+parseInt(stationStats.actualFriction,10);
            if (total===0){
                total =stationStats.numberOfWheels;
            }
            if (total===0){
                total=1;
            }

            stationStats.actualSpikes = Math.floor(stationStats.actualSpikes/total*100);
            stationStats.actualFriction = 100 - stationStats.actualSpikes;

            stationStats.onStation =  parseInt(stationStats.onStation,10);
            stationStats.orders =  parseInt(stationStats.orders,10);
            stationStats.outgoing =  parseInt(stationStats.outgoing,10);

            return {
                ...state,
                currentStationStats: stationStats
            };
        case "STATIONS_STATS_GET_FAILURE":
            return {
                ...state,
                currentStationStats:{}
            };


        //destroy
        case 'STATIONS_DESTROY_SUCCESS':
            return {
                ...state
            };
        case 'STATIONS_DESTROY_FAILURE':
            return {
                ...state
            };


        case "STATIONS_GET_GROUP_TYPES_SUCCESS":
            return{
                ...state,
                groupTypes:action.payload
            }

        case "STATIONS_GET_GROUP_TYPES_FAILED":
            return{
                ...state,
                groupTypes:[]
            }


        default:
            return state;

    }
}









// WEBPACK FOOTER //
// ./src/reducers/stations.js